module.exports = __webpack_public_path__ + "img/icon-over-human-req.b3121541.svg";